(ns iris.firebase
  (:require
   [re-frame.core :as re-frame]
   [cljs.core.async :refer [chan promise-chan go >! <! put! mult tap alts! timeout]]
   [cljs.core.async.interop :refer-macros [<p!]]
   ["firebase/app" :as firebase]
   ["firebase/database" :as database]
   ["firebase/auth" :as auth]
   [iris.events :as events]
   [iris.globals :as globals]
   
   [reagent.core :as r]
   ))



(goog-define API-KEY "")
(goog-define AUTH-DOMAIN "")
(goog-define PROJECT-ID "")
(goog-define MESSAGING-SENDER-ID "")
(goog-define DATABASE-URL "")


(def timestamp (aget firebase/database.ServerValue "TIMESTAMP"))


;; (defn auth-promise []
;;   (new js/Promise
;;        (fn [resolve _]

;;          (if (some? @globals/fb-user)
;;            (resolve @globals/fb-user)
;;            (let [kw (keyword (str "fb-user" (rand-int 1000)))]
;;              (add-watch globals/fb-user kw
;;                         (fn [key atom old-state new-state]
;;                           (when new-state
;;                             (remove-watch globals/fb-user kw)
;;                             (resolve new-state)))))))))


;; (defn set-fb-auth-data [fb-user raidpurge roles]
;;   ;; (re-frame/dispatch [::events/set-initfb-user fb-user]) ;; not used
;;   ;; (re-frame/dispatch [::events/set-raidpurger raidpurge]) ;; not needed anymore (raids not used)
;;   (println (str "set-fb-auth-data: " fb-user raidpurge roles))
;;   ;; (re-frame/dispatch [::events/set-roles (set roles)]) ;; roles should not be set from fb, failed auth or auth change could wipe them out. roles are available in jwt token and should be written from there
;;   )


;; 04/18/2024
;; TODO:
;; firebase gets disconnected, fb-user, roles get wiped out in on-auth-state-changed
;; going to turn that off, that should be handled in login>events>logout
;; ideally here we would retry reconnect
;; also roles should not be set here - roles are available from jwt token, as is uid
;; (defn on-auth-state-changed []
;;   (.onAuthStateChanged (firebase/auth)
;;                        (fn [user]
;;                          (if (some? user)
;;                            (-> firebase
;;                                (.. auth -currentUser getIdTokenResult)
;;                                (.then (fn [^js idTokenResult]
;;                                         (set-fb-auth-data (.. idTokenResult -claims -user_id)
;;                                                           (.. idTokenResult -claims -raidpurge)
;;                                                           (js->clj (.. idTokenResult -claims -roles)))
;;                                         (reset! globals/fb-user (.. idTokenResult -claims -user_id)))))
;;                            (do
;;                              (set-fb-auth-data nil nil nil)
;;                              (reset! globals/fb-user nil))))))

;; (defn on-auth-state-changed []
;;   (.onAuthStateChanged (firebase/auth)
;;                        (fn [user]
;;                          (if (some? user)
;;                            (do
;;                              (-> firebase
;;                                  (.. auth -currentUser getIdTokenResult)
;;                                  (.then (fn [^js idTokenResult]
;;                                           ;; (set-fb-auth-data (.. idTokenResult -claims -user_id)
;;                                           ;;                   (.. idTokenResult -claims -raidpurge)
;;                                           ;;                   (js->clj (.. idTokenResult -claims -roles)))
;;                                           (.log js/console "RESULTSSSS0000:" (.. idTokenResult -claims -user_id) idTokenResult)
;;                                           (reset! globals/fb-user (.. idTokenResult -claims -user_id)))))
;;                              (re-frame/dispatch [::events/set-fb-auth-state true])
;;                              (.log js/console "FB auth state changed, user signed in." user))
;;                            (do
;;                              (re-frame/dispatch [::events/set-fb-auth-state false])
;;                              (println "FB auth state changed, user signed out." (alength firebase/apps))
;;                             ;;  TODO delete set-fb-auth-data, reset fb-user, rest fbjwt
;;                             ;;  (set-fb-auth-data nil nil nil)
;;                             ;;  (reset! globals/fb-user nil)
;;                             ;;  (reset! globals/fbjwt nil)
;;                              )))))
  





  ;; (defn sign-in []
  ;;   ;; TODO: validate fbjt instead of just checking for it
  ;;   (when @globals/fbjwt
  ;;     (-> (firebase/auth)
  ;;         (.signInWithCustomToken @globals/fbjwt)
  ;;         (.then (fn [^js result]
  ;;                  (.log js/console "RESULTSSSS1111:" @globals/fb-user result)
  ;;                                      (.postMessage globals/fb-broadcast-channel (clj->js {:type "fb-sign-in-success"}))
                   
  ;;                  (when (nil? @globals/fb-user)
  ;;                    (println "RESULTSSSS2222:")
  ;;                    (doseq [f @globals/exec-on-fb-sign-in]
  ;;                      (f)))
  ;;                  )
  ;;                )
  ;;         (.catch (fn [e]
  ;;                   (when-let [handler (:error-handler "signin")]
  ;;                     (handler e)))))))


;; (defn sign-out []
;;   (doseq [f @globals/exec-on-fb-sign-out]
;;     (f))
;;   (.signOut (firebase/auth))
;;   (.. firebase app delete))


;; (defn firebase-init []
;;   (if (zero? (alength firebase/apps))
;;     (firebase/initializeApp
;;      #js {:apiKey API-KEY
;;           :authDomain AUTH-DOMAIN
;;           :projectId PROJECT-ID
;;           :storageBucket ""
;;           :messagingSenderId MESSAGING-SENDER-ID
;;           :databaseURL DATABASE-URL})
;;     (firebase/app))
;;   (on-auth-state-changed))




;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; v1

;; ;; Your Firebase config
;; (def firebase-config
;;   #js {:apiKey API-KEY
;;        :authDomain AUTH-DOMAIN
;;        :databaseURL DATABASE-URL
;;        :projectId PROJECT-ID
;;        :storageBucket ""
;;        :messagingSenderId MESSAGING-SENDER-ID
;;        ;;  :appId ""
;;        })

;; ;; Ensure Firebase app is only initialized once
;; (defonce firebase-app
;;   (when (zero? (.. firebase -apps -length))
;;     (.initializeApp firebase firebase-config)))




;; ;; Shared user auth channel that broadcasts to multiple listeners
;; (defonce user-auth-promise (promise-chan))
;; (defonce user-auth-mult (mult user-auth-promise))

;; (defn wait-for-auth-user []
;;   "Allows other parts of the app to wait until the user is signed in."
;;   (let [c (chan)]
;;     (tap user-auth-mult c)
;;     c))


;; (defn wait-for-auth-user-with-timeout [timeout-ms]
;;   "Returns a channel that yields the user or :auth-timeout if timeout elapses before auth completes."
;;   (let [c (chan)
;;         tap-ch (chan)]
;;     (tap user-auth-mult tap-ch)
;;     (go
;;       (let [[val ch] (alts! [tap-ch (timeout timeout-ms)])]
;;         (if (= ch tap-ch)
;;           (>! c val)
;;           (>! c :auth-timeout))))
;;     c))


;; (defn sign-in-with-token-watcher
;;   "Signs in with a Firebase custom token and waits for auth state to be ready.
;;    Returns a core.async channel with the user or an error."
;;   [^string token]
;;   (let [out (chan)
;;         auth-instance (.auth firebase)
;;         unsub (atom nil)]

;;     ;; Attach auth state listener and store unsubscribe function
;;     (reset! unsub
;;             (.onAuthStateChanged
;;              auth-instance
;;              (fn [user]
;;                (when user
;;                  (when @unsub (@unsub))
;;                  (go (>! out user))))
;;              (fn [err]
;;                (go (>! out err)))))

;;     ;; Start sign-in attempt
;;     (go
;;       (try
;;         (<p! (.signInWithCustomToken auth-instance token))
;;         (catch :default e
;;           (when @unsub (@unsub))
;;           (>! out e))))

;;     ;; Return result channel
;;     out))

;; ;; Sign out function
;; (defn sign-out []
;;   (let [auth-instance (.auth firebase)]
;;     (-> (.signOut auth-instance)
;;         (.then (fn []
;;                  (js/console.log "Signed out successfully.")
;;                  (doseq [f @globals/exec-on-fb-sign-out]
;;                    (f))))
;;         (.catch (fn [err] (js/console.error "Sign-out error:" err))))))



;; ;; Entry point example
;; (defn init! []
;;   (go
;;     (let [token @globals/fbjwt ; Replace with your real token
;;           result (<! (sign-in-with-token-watcher token))]
;;       (if (instance? js/Error result)
;;         (js/console.error "Failed to sign in:" result)
;;         (do
;;           (js/console.log "Signed in as UID:" (.-uid result))
;;           (reset! globals/fb-user (.-uid result)) 
;;           (doseq [f @globals/exec-on-fb-sign-in]
;;             (println "exec-on-fb-sign-in:" f)
;;             (f))
;;           ;; (>! user-auth-chan result)
;;           (put! user-auth-promise result)
;;           )))))


;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;


;; v2

;; ---------------------------------------------
;; Firebase Auth Integration (Custom Token, No Re-frame)
;; ---------------------------------------------


;; Your Firebase config
(def firebase-config
  #js {:apiKey API-KEY
       :authDomain AUTH-DOMAIN
       :databaseURL DATABASE-URL
       :projectId PROJECT-ID
       :storageBucket ""
       :messagingSenderId MESSAGING-SENDER-ID
       ;;  :appId ""
       })

;; Ensure Firebase app is only initialized once
(defonce firebase-app
  (when (zero? (.. firebase -apps -length))
    (.initializeApp firebase firebase-config)))


(defonce user-atom (r/atom nil))
(defonce auth-callbacks (atom []))

(defn authenticated? []
  (println "authenticated?:" @user-atom)
  (some? @user-atom))

(defn current-user []
  @user-atom)

(defn on-auth-ready [callback]
  (if (authenticated?)
    (callback @user-atom)
    (swap! auth-callbacks conj callback)))

;; wait-for-auth-user works but resolves only once
;; need mult tap to allow multiple listeners work
;; had difficulty making it work, using promise version instead
(defn wait-for-auth-user []
  (let [c (chan)]
    (on-auth-ready #(put! c %))
    c))

(defn wait-for-auth-user-promise []
  (js/Promise.
   (fn [resolve _reject]
     (on-auth-ready resolve))))

(defn wait-for-auth-user-with-timeout [timeout-ms callback]
  (let [result-chan (chan)
        to-chan (timeout timeout-ms)]
    (on-auth-ready #(put! result-chan %))
    (go
      (let [[val port] (alts! [result-chan to-chan])]
        (callback (if (= port to-chan) nil val))))))

(defn sign-in-with-custom-token! [token on-success on-error]
  (-> (.signInWithCustomToken (.auth firebase) token)
      (.then (fn [user-cred]
               ;; No need to update user-atom here; it's handled in onAuthStateChanged
               (on-success user-cred)))
      (.catch (fn [err] (on-error err)))))

(defn sign-out! []
  (-> (.signOut (.auth firebase))
      (.then (fn []
               (reset! user-atom nil)
               (js/console.log "Signed out")))
      (.catch (fn [err] (js/console.error "Sign-out failed:" err)))))

(defn init-auth! [token]
  (.onAuthStateChanged
   (.auth firebase)
   (fn [user]
     (reset! user-atom user)
     (doseq [cb @auth-callbacks]
       (cb user))
     (reset! auth-callbacks []))
   (fn [err]
     (println "error:" err)))
  (sign-in-with-custom-token!
   token
   (fn [_] (js/console.log "Auto login successful"))
   (fn [err] (js/console.error "Auto login failed:" err))))


;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;











  (defn set-raid2eid [abbr eid]
    (.. firebase database (ref (str "raid2eid" "/" abbr)) (set  eid)
              ;;  (transaction (fn [current] (if (not-empty current) current eid))
              ;;               (fn [error committed snapshot]
              ;;                 (when (true? committed)
              ;;                   (resolve committed))))
        ))


(defn get-raid2eid [abbr]
  (new js/Promise
       (fn [resolve _]
         (.. firebase database (ref (str "raid2eid" "/" abbr))
             (once "value"
                   (fn success [snapshot]
                     (let [data (-> snapshot .val (js->clj :keywordize-keys true))]
                       (resolve data)))
                   (fn failure [error] (.log js/console error)))))))


(defn get-eid2raid [eid]
  (new js/Promise
       (fn [resolve _]
         (.. firebase database (ref (str "eid2raid" "/" eid))
             (once "value"
                   (fn success [snapshot]
                     (let [data (-> snapshot .val (js->clj :keywordize-keys true))]
                       (resolve data)))
                   (fn failure [error] (.log js/console error)))))))


(defn reset-eid2raid []
  (.. firebase database
      (ref "eid2raid")
      (remove)))

(defn reset-raid2eid []
  (.. firebase database
      (ref "raid2eid")
      (remove)))


(defn reset-raid-cache-id []
  (.. firebase database
      (ref "raid-cache-id")
      (set (clj->js {:datetime timestamp
                      ;;  :user (.. js/appConfig -jwt_claims -uid)
                     :user (:uid @globals/fbjwt-payload)}))))


;; need to unbind bind-raid-cache-id - live data!
(defn unbind-raid-cache-id []
  (.off (.. firebase database (ref "raid-cache-id"))))

;; NOTE: 04/19/2024 raid cache id no longer needed
;; (swap! globals/exec-on-fb-sign-out #(conj @globals/exec-on-fb-sign-out unbind-raid-cache-id))


(defn bind-raid-cache-id [on-update-handler]
  (.. firebase database (ref "raid-cache-id")
      (on "value"
          (fn success [snapshot]
            (let [data (-> snapshot .val (js->clj :keywordize-keys true))]
              (when-not (empty? data)
                (on-update-handler data))))
          (fn failure [error] (.log js/console error)))))


(defn get-post-votes [ws forum thread nick on-update-handler]
  (.. firebase database (ref (str ws "/post-votes/" forum "/" thread "/" nick))
      (once "value"
            (fn success [snapshot]
              (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) {:d 0 :t 0 :u 0 :z 0})]
                ;; (re-frame/dispatch [::set-fb-data-row :votes (str nick thread) data])
                (on-update-handler nick thread data))
              (fn failure [error] (.log js/console error))))))


(defn <p-get-post-votes [ws forum thread nick]
  (new js/Promise
       (fn [resolve _]
         (.. firebase database (ref (str ws "/post-votes/" forum "/" thread "/" nick))
             (once "value"
                   (fn success [snapshot]
                     (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) {:d 0 :t 0 :u 0 :z 0})]
                       (resolve data))
                     (fn failure [error]
                       (.log js/console error)
                       (resolve {:d 0 :t 0 :u 0 :z 0}))))))))


(defn get-replies [ws thread on-update-handler]
  ;; TLO/replies/+102aFmrD
         (.. firebase database (ref (str ws "/replies/" thread))
             (once "value"
                   (fn success [snapshot]
                     (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) {:n 0 :t nil})]
                      ;;  (re-frame/dispatch [::set-fb-data-row :replies (str "@OP" thread) data])
                       (on-update-handler thread data)))
                   (fn failure [error] (.log js/console error)))))


(defn <p-get-replies [ws thread]
  ;; TLO/replies/+102aFmrD
  (new js/Promise
       (fn [resolve _]
         (.. firebase database (ref (str ws "/replies/" thread))
             (once "value"
                   (fn success [snapshot]
                     (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) {:n 0 :t nil})]
                       (resolve data)))
                   (fn failure [error]
                     (.log js/console error)
                     (resolve {:n 0 :t nil})))))))


(defn <p-get-replies-t [ws thread]
  ;; TLO/replies/+102aFmrD/t
  (new js/Promise
       (fn [resolve _]
         (.. firebase database (ref (str ws "/replies/" thread "/t"))
             (once "value"
                   (fn success [snapshot]
                     (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) nil)]
                       (resolve data)))
                   (fn failure [error]
                     (.log js/console error)
                     (resolve nil)))))))


(defn <p-get-shares [ws share-page-kind ruid]
  ;; `${this.ws}/shares/${this.pageKind}/${this.ruid}`,
  (new js/Promise
       (fn [resolve _]
         (.. firebase database (ref (str ws "/shares/" share-page-kind "/" ruid))
             (once "value"
                   (fn success [snapshot]
                     (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) {})]
                       (resolve data)))
                   (fn failure [error]
                     (.log js/console error)
                     (resolve {})))))))


(defn push-admin-shares-log [data]
  ;; `admin-sessions/${this.baseUserUid}/share-log`
  ;; db.ref (path) .push (val)
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/" uid "/share-log")
        data-ts (assoc data :datetime timestamp :uid uid)]
    (.. firebase database
        (ref path)
        (push (clj->js data-ts)))))


(defn push-admin-votes-log [data]
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/" uid "/vote-log")
        data-ts (assoc data :datetime timestamp :uid uid)]
    (.. firebase database
        (ref path)
        (push (clj->js data-ts)))))


(defn set-thread-follow [data]
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/" uid "/thread-follow/" (:id data))]
    (.. firebase database
        (ref path)
        (set (clj->js data)))))


(defn remove-thread-follow [id]
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/" uid "/thread-follow/" id)]
    (.. firebase database
        (ref path)
        (remove))))


(defn set-thread-follow-t [id t]
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/" uid "/thread-follow/" id "/t")]
    (.. firebase database
        (ref path)
        (set t))))


(defn <p-get-thread-follow [id]
  (new js/Promise
       (fn [resolve _]
         (let [uid (:uid @globals/fbjwt-payload)
               path (str "admin-sessions/" uid "/thread-follow/" id)]
           (.. firebase database (ref path)
               (once "value"
                     (fn success [snapshot]
                       (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) nil)]
                         (resolve data)))
                     (fn failure [error]
                       (.log js/console error)
                       (resolve nil))))))))


;; (defn <p-get-all-thread-follow []
;;   (new js/Promise
;;        (fn [resolve _]
;;          (let [uid (:uid @globals/fbjwt-payload)
;;                path (str "admin-sessions/" uid "/thread-follow")]
;;            (.. firebase database (ref path)
;;                (once "value"
;;                      (fn success [snapshot]
;;                        (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) {})]
;;                          (resolve data)))
;;                      (fn failure [error] (.log js/console error))))))))

;; NOTE: pass in uid so it can work from worker
(defn <p-get-all-thread-follow [uid]
  (new js/Promise
       (fn [resolve _]
         (let [path (str "admin-sessions/" uid "/thread-follow")]
           (.. firebase database (ref path)
               (once "value"
                     (fn success [snapshot]
                       (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) {})]
                         (resolve data)))
                     (fn failure [error]
                       (.log js/console error)
                       (resolve {}))))))))


(defn set-defaults-ws [ws]
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/" uid "/defaults/ws")]
    (.. firebase database
        (ref path)
        (set ws))))

(defn set-last-action [data]
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/all/last-action/" uid)]
    (.. firebase database
        (ref path)
        (set (clj->js {:action data :datetime timestamp}) ))))


(defn <p-get-defaults-ws []
  (new js/Promise
       (fn [resolve _]
         (let [uid (:uid @globals/fbjwt-payload)
               path (str "admin-sessions/" uid "/defaults/ws")]
           (.. firebase database (ref path)
               (once "value"
                     (fn success [snapshot]
                       (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) nil)]
                         (resolve data)))
                     (fn failure [error]
                       (.log js/console error)
                       (resolve nil))))))))


(defn get-default-ws [default]
  (let [uid (:uid @globals/fbjwt-payload)
        path (str "admin-sessions/" uid "/defaults/ws")
        ref (.ref (.database firebase) path)]
    (-> (.once ref "value")
        (.then (fn [snapshot]
                 (let [val (.val snapshot)]
                   (if (some? val)
                     val
                     default))))
        (.catch (fn [err]
                  (js/console.error "Firebase read error:" err)
                  default)))))


;; WE ARE NO LONGER PUSHING MODEARATION LOGS DATA TO FB, BACKEND DOES IT NOW
(defn push-admin-all-moderation-log [data]
  ;; `admin-sessions/${this.baseUserUid}/share-log`
  ;; db.ref (path) .push (val)
  (let [uid (:uid @globals/fbjwt-payload)
        ;; path (str "admin-sessions/" uid "/share-log")
        path (str "admin-sessions/all/moderation-log/" (:ws data) "/" (:id data))
        data-ts (assoc data :datetime timestamp :uid uid)]
    (.. firebase database
        (ref path)
        (push (clj->js data-ts)))))

;; WE ARE NO LONGER PUSHING MODEARATION LOGS DATA TO FB, BACKEND DOES IT NOW
(defn push-admin-moderation-log [data]
  ;; `admin-sessions/${this.baseUserUid}/share-log`
  ;; db.ref (path) .push (val)
  (let [uid (:uid @globals/fbjwt-payload)
        ;; path (str "admin-sessions/" uid "/share-log")
        path (str "admin-sessions/" uid "/moderation-log/" (:ws data))
        data-ts (assoc data :datetime timestamp :uid uid)]
    (.. firebase database
        (ref path)
        (push (clj->js data-ts)))))


;; (defn <p-get-admin-moderation-logs [ws]
;;   (new js/Promise
;;        (fn [resolve _]
;;          (let [uid (:uid @globals/fbjwt-payload)
;;               ;;  path (str "admin-sessions/" uid "/moderation-log/" ws)
;;                path (str "admin-sessions/" uid "/moderation/" ws)]
;;            (.. firebase database (ref path)
;;               ;;  (orderByKey)
;;                (limitToLast (:limit-to-last globals/MODERATOR_LOG_SETTINGS))
;;                (once "value"
;;                      (fn success [snapshot]
;;                        (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) nil)]
;;                          (resolve data)))
;;                      (fn failure [error] (.log js/console error))))))))

;; NOTE: when called from worker, uid from globals seems to be not available thus pass in as argument
;; TODO: revisit other fb functions, pass in uid as opposed to getting it from globals/fbjwt
(defn <p-get-admin-moderation-logs [ws uid]
  (new js/Promise
       (fn [resolve _]
         (let [path (str "admin-sessions/" uid "/moderation/" ws)]
           (.. firebase database (ref path)
              ;;  (orderByKey)
               (limitToLast (:limit-to-last globals/MODERATOR_LOG_SETTINGS))
               (once "value"
                     (fn success [snapshot]
                       (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) nil)]
                         (resolve data)))
                     (fn failure [error]
                       (.log js/console error)
                       (resolve nil))))))))


(defn <p-get-admin-all-moderation-logs [ws ruid]
  (new js/Promise
       (fn [resolve _]
         (let [uid (:uid @globals/fbjwt-payload)
              ;;  path (str "admin-sessions/all/moderation-log/" ws "/" ruid)
               path (str "admin-sessions/all/moderation/" ws "/" ruid)]
          ;;  (println "all moderation path:" path)
           (.. firebase database (ref path)
               (once "value"
                     (fn success [snapshot]
                       (let [data (or (-> snapshot .val (js->clj :keywordize-keys true)) nil)]
                         (resolve data)))
                     (fn failure [error]
                       (.log js/console error)
                       (resolve nil))))))))


